import { z } from "zod";
import { adoptResultSchema } from "./fanout.js";
import { competitorSuggestionSchema, researchResultSchema } from "./research.js";
/** Whether the brand's site could be read during report setup. */
export const setupBriefSchema = z.discriminatedUnion("outcome", [
    z.object({ outcome: z.literal("ready") }),
    z.object({ outcome: z.literal("refused_by_robots"), rule: z.string() }),
    z.object({ outcome: z.literal("unreadable") }),
    z.object({ outcome: z.literal("no_model") }),
]);
/** Suggested questions and the sentence they were written from. */
export const setupPromptsSchema = z.object({
    describes: z.string(),
    candidates: researchResultSchema.shape.candidates,
    rejected: researchResultSchema.shape.rejected,
});
/** The resumable, user-facing state of an unfinished report. */
export const reportSetupSchema = z.object({
    brief: setupBriefSchema.nullable(),
    competitors: competitorSuggestionSchema.shape.competitors.nullable(),
    prompts: setupPromptsSchema.nullable(),
});
export const writeSetupPromptsSchema = z.object({
    describes: z.string().trim().max(400),
});
/** The one operation that turns resumable setup into an active report. */
export const finishSetupSchema = z.object({
    texts: z.array(z.string().trim().min(3).max(500)).min(1).max(100),
});
export const finishedSetupSchema = adoptResultSchema;
/** Setup discard never cancels captures because setup cannot own prompt links. */
export const discardedSetupSchema = z.object({ brandDeleted: z.boolean() });
/** Stored rows also keep model provenance for proposed content (§14a.6). */
export const storedSetupSchema = z.object({
    brief: setupBriefSchema.nullable(),
    competitors: competitorSuggestionSchema.nullable(),
    prompts: z.object({ describes: z.string(), result: researchResultSchema }).nullable(),
});
//# sourceMappingURL=setup.js.map